import { PartnershipMode } from 'core/agency/Agency';
import i18n from 'i18n';

// 後端序列化會在值為 null 時整個省略這個 key，所以這裡收到的可能是 undefined。
// PartnershipMode[未知數值] 同樣是 undefined，順帶涵蓋值域外的 id。
export function getPartnershipModeLabel (partnershipModeId?: PartnershipMode): string {
  const modeName = PartnershipMode[partnershipModeId as PartnershipMode];
  if (!modeName) {
    return i18n.t<string>('common.labels.noData');
  }
  return i18n.t<string>(`common.partnershipMode.${modeName.toLowerCase()}`);
}
